import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from './cliente';
import { chaves } from './query';
import type { Projeto } from './tipos';

/** Lista de projetos do integrador (alimenta o histórico). */
export function useProjetos() {
  return useQuery({
    queryKey: chaves.projetos,
    queryFn: () => api.obter<Projeto[]>('/projetos'),
  });
}

/** O projeto em edição. É o que o funil carrega ao abrir a tela de preço. */
export function useProjetoAtual() {
  return useQuery({
    queryKey: chaves.projetoAtual,
    queryFn: () => api.obter<Projeto | null>('/projetos/atual'),
  });
}

export function useSalvarProjeto() {
  const clienteQuery = useQueryClient();
  return useMutation({
    mutationFn: (projeto: Partial<Projeto> & { id?: string }) =>
      projeto.id
        ? api.salvar<Projeto>(`/projetos/${projeto.id}`, projeto)
        : api.criar<Projeto>('/projetos', projeto),
    onSuccess: (projeto) => {
      clienteQuery.setQueryData(chaves.projetoAtual, projeto);
      void clienteQuery.invalidateQueries({ queryKey: chaves.projetos });
      void clienteQuery.invalidateQueries({ queryKey: ['calculo'] });
    },
  });
}

export function useRemoverProjeto() {
  const clienteQuery = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.remover<void>(`/projetos/${id}`),
    onSuccess: () => {
      void clienteQuery.invalidateQueries({ queryKey: chaves.projetos });
      void clienteQuery.invalidateQueries({ queryKey: chaves.projetoAtual });
    },
  });
}
